export const styles = {
    pageWrapper: {
        padding: '24px 28px',
        minHeight: '100vh',
        background: '#f8fafb',
    },
    pageHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '22px',
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
    },
    btnBack: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '7px 16px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#fff',
        border: '1.5px solid #bbf7d0',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        textDecoration: 'none',
    },
    pageTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    pageTitleIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '9px',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: '0 2px 8px rgba(26,125,62,0.25)',
    },
    pageTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#111827',
        margin: 0,
    },
    countBadge: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#dcfce7',
        borderRadius: '20px',
        padding: '2px 10px',
    },
    btnAddTemplate: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '8px 18px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#fff',
        backgroundColor: '#1a7d3e',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        boxShadow: '0 2px 6px rgba(26,125,62,0.3)',
    },
    tableCard: {
        background: '#fff',
        borderRadius: '14px',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    },
    tableScroll: {
        overflowX: 'auto',
        maxHeight: '72vh',
        overflowY: 'auto',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '13.5px',
    },
    theadRow: {
        background: 'linear-gradient(135deg, #f0fdf4 0%, #e8f5e9 100%)',
        borderBottom: '2px solid #d1fae5',
        position: 'sticky',
        top: 0,
        zIndex: 10,
    },
    th: {
        padding: '12px 16px',
        textAlign: 'left',
        fontSize: '11px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.055em',
        whiteSpace: 'nowrap',
    },
    thNoSort: {
        padding: '12px 16px',
        textAlign: 'left',
        fontSize: '11px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.055em',
        whiteSpace: 'nowrap',
    },
    row: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #f3f4f6',
        transition: 'background-color 0.15s ease',
    },
    td: {
        padding: '12px 16px',
        color: '#374151',
        fontSize: '13.5px',
        verticalAlign: 'middle',
    },
    indexCell: {
        padding: '12px 16px',
        color: '#9ca3af',
        fontWeight: '600',
        fontSize: '13px',
        verticalAlign: 'middle',
        width: '52px',
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    avatar: {
        width: '32px',
        height: '32px',
        borderRadius: '8px',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        fontWeight: '700',
        flexShrink: 0,
    },
    nameText: {
        fontWeight: '600',
        color: '#111827',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '140px',
    },
    subjectCell: {
        padding: '11px 16px',
        verticalAlign: 'middle',
    },
    subjectText: {
        display: 'block',
        color: '#6b7280',
        fontSize: '13px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        cursor: 'default',
    },
    dateBadge: {
        display: 'inline-block',
        padding: '3px 10px',
        backgroundColor: '#f3f4f6',
        borderRadius: '20px',
        fontSize: '12px',
        color: '#6b7280',
        fontWeight: '500',
        whiteSpace: 'nowrap',
    },
    actionGroup: {
        display: 'flex',
        gap: '6px',
        alignItems: 'center',
        justifyContent: 'center',
        whiteSpace: 'nowrap',
    },
    actionCell: {
        padding: '11px 16px',
        verticalAlign: 'middle',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        width: '110px',
    },
    statusCell: {
        padding: '11px 16px',
        verticalAlign: 'middle',
        textAlign: 'center',
        width: '80px',
    },
    btnView: {
        width: '30px',
        height: '30px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '7px',
        border: '1px solid #e5e7eb',
        background: '#f9fafb',
        color: '#6b7280',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        fontSize: '14px',
    },
    btnEdit: {
        width: '30px',
        height: '30px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '7px',
        border: '1px solid #d1fae5',
        background: '#f0fdf4',
        color: '#1a7d3e',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        fontSize: '14px',
    },
    btnDelete: {
        width: '30px',
        height: '30px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '7px',
        border: '1px solid #fee2e2',
        background: '#fff5f5',
        color: '#dc2626',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        fontSize: '14px',
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 0',
        color: '#9ca3af',
    },
    emptyText: {
        marginTop: '14px',
        fontSize: '14px',
        color: '#9ca3af',
        fontWeight: '500',
    },
};
